//Blocchi - structure: [name,img,[array of links]]    // if 1 link => direct link, otherwise overlay to choose between SMART (the first) and STANDARD (the second)
var base_path="https://configurator.creative-cables.com/customize";
var subfolder="assets_new_landing";
var title="Kaj želite konfigurirati?";
var smart="Konfiguriraj zdaj SMART različico";
var standard="Konfiguriraj zdaj STANDARD različico";

let lampade_da_soffitto = [
    ["Enojna viseča svetilka", base_path+"/"+subfolder+"/img/grid/14.svg", [base_path+"/frontend.php?id_model=14"]],
    ["Enojna viseča svetilka za tirnico", base_path+"/"+subfolder+"/img/grid/113.svg", [base_path+"/frontend.php?id_model=113"]],
    ["Enojna viseča svetilka s Flexom", base_path+"/"+subfolder+"/img/grid/51.svg", [base_path+"/frontend.php?id_model=51"]],
    ["Viseča svetilka z 2 kabli", base_path+"/"+subfolder+"/img/grid/12.svg", [base_path+"/frontend.php?id_model=12"]],
    ["Viseča svetilka s 3 kabli", base_path+"/"+subfolder+"/img/grid/92.svg", [base_path+"/frontend.php?id_model=92"]],
    ["Viseča svetilka s 4 kabli", base_path+"/"+subfolder+"/img/grid/85.svg", [base_path+"/frontend.php?id_model=85"]],
    ["Rose-One 2 kabli", base_path+"/"+subfolder+"/img/grid/13.svg", [base_path+"/frontend.php?id_model=13"]],
    ["Rose-One 3 kabli", base_path+"/"+subfolder+"/img/grid/33.svg", [base_path+"/frontend.php?id_model=33"]],
    ["Rose-One 4 kabli", base_path+"/"+subfolder+"/img/grid/35.svg", [base_path+"/frontend.php?id_model=35"]],
    ["Lestenec s kletko", base_path+"/"+subfolder+"/img/grid/71.svg", [base_path+"/frontend.php?id_model=71"]],
    ["Reflektor za tirnico", base_path+"/"+subfolder+"/img/grid/333.svg", [base_path+"/frontend.php?id_model=333"]],
];

let lampade_da_parete = [
    ["Fermaluce", base_path+"/"+subfolder+"/img/grid/22.svg", [base_path+"/frontend.php?id_model=22"]],
    ["Fermaluce z gibljivim členom", base_path+"/"+subfolder+"/img/grid/23.svg", [base_path+"/frontend.php?id_model=23"]],
    ["Fermaluce s podaljškom v obliki črke L", base_path+"/"+subfolder+"/img/grid/24.svg", [base_path+"/frontend.php?id_model=24"]],
    ["Fermaluce s podaljškom v obliki črke S", base_path+"/"+subfolder+"/img/grid/128.svg", [base_path+"/frontend.php?id_model=128"]],
    ["Fermaluce s Flex", base_path+"/"+subfolder+"/img/grid/50.svg", [base_path+"/frontend.php?id_model=50"]],
    ["Spostaluce", base_path+"/"+subfolder+"/img/grid/62.svg", [base_path+"/frontend.php?id_model=62"]],
    ["Spostaluce z gibljivim členom", base_path+"/"+subfolder+"/img/grid/63.svg", [base_path+"/frontend.php?id_model=63"]],
    ["Spostaluce s podaljškom v obliki črke L", base_path+"/"+subfolder+"/img/grid/64.svg", [base_path+"/frontend.php?id_model=64"]],
    ["Spostaluce s Flexom", base_path+"/"+subfolder+"/img/grid/65.svg", [base_path+"/frontend.php?id_model=65"]],
    ["Spostaluce 3 svetlobne točke", base_path+"/"+subfolder+"/img/grid/94.svg", [base_path+"/frontend.php?id_model=94"]],
];

let lampade_da_tavolo = [
    ["Posaluce", base_path+"/"+subfolder+"/img/grid/66.svg", [base_path+"/frontend.php?id_model=66"]],
    ["Posaluce s podaljškom", base_path+"/"+subfolder+"/img/grid/67.svg", [base_path+"/frontend.php?id_model=67"]],
    ["Posaluce s Flex", base_path+"/"+subfolder+"/img/grid/58.svg", [base_path+"/frontend.php?id_model=58"]],
    ["Svetilka na baterije", base_path+"/"+subfolder+"/img/grid/99.svg", [base_path+"/frontend.php?id_model=99"]],
    ["Cubetto", base_path+"/"+subfolder+"/img/grid/21.svg", [base_path+"/frontend.php?id_model=21"]],
    ["Tache", base_path+"/"+subfolder+"/img/grid/25.svg", [base_path+"/frontend.php?id_model=25"]],
    ["Materia", base_path+"/"+subfolder+"/img/grid/26.svg", [base_path+"/frontend.php?id_model=26"]],
];

let lampade_da_terra = [
    ["Magnetna svetilka", base_path+"/"+subfolder+"/img/grid/123.svg", [base_path+"/frontend.php?id_model=123"]],
];

let lampade_plug_in = [
    ["Svetilka s priključkom", base_path+"/"+subfolder+"/img/grid/31.svg", [base_path+"/frontend.php?id_model=31"]],
    ["Zunanja svetilka s priključkom", base_path+"/"+subfolder+"/img/grid/29.svg", [base_path+"/frontend.php?id_model=29"]],
];

let lampade_outdoor = [
    ["Svetilka s priključkom", base_path+"/"+subfolder+"/img/grid/29.svg", [base_path+"/frontend.php?id_model=29"]],
    ["Svetilka s stropno rozeto", base_path+"/"+subfolder+"/img/grid/45.svg", [base_path+"/frontend.php?id_model=45"]],
    ["Stenska svetilka z gibljivim členom", base_path+"/"+subfolder+"/img/grid/43.svg", [base_path+"/frontend.php?id_model=43"]],
    ["Stenska svetilka s podaljškom", base_path+"/"+subfolder+"/img/grid/41.svg", [base_path+"/frontend.php?id_model=41"]],
    ["Viseča svetilka z 2 kabli za zunanjo uporabo", base_path+"/"+subfolder+"/img/grid/75.svg", [base_path+"/frontend.php?id_model=75"]],
    ["Viseča svetilka v vrsti z 2 kabli", base_path+"/"+subfolder+"/img/grid/48.svg", [base_path+"/frontend.php?id_model=48"]],
    ["Viseča svetilka s 3 kabli za zunanjo uporabo", base_path+"/"+subfolder+"/img/grid/77.svg", [base_path+"/frontend.php?id_model=77"]],
    ["Svetlobna veriga z 2 kabli", base_path+"/"+subfolder+"/img/grid/79.svg", [base_path+"/frontend.php?id_model=79"]],
    ["Svetlobna veriga s 3 kabli", base_path+"/"+subfolder+"/img/grid/81.svg", [base_path+"/frontend.php?id_model=81"]],
];

let multiprese_prolunghe = [
    ["Razdelilec", base_path+"/"+subfolder+"/img/grid/39.svg", [base_path+"/frontend.php?id_model=39"]],
    ["Podaljšek", base_path+"/"+subfolder+"/img/grid/40.svg", [base_path+"/frontend.php?id_model=40"]],
];

let cablaggi = [
    ["Ožičenje", base_path+"/"+subfolder+"/img/grid/37.svg", [base_path+"/frontend.php?id_model=37"]],
];

let rosoni = [
    ["Rozete XXL",base_path+"/"+subfolder+"/img/grid/330.svg",[base_path+"/frontend.php?id_model=329"]],
];

//Menu - structure: [name,img,anchor, product list (above)]
let l = [
    ["Stropne svetilke", "", "lampade-da-soffitto", lampade_da_soffitto],
    ["Stenske svetilke", "", "lampade-da-parete", lampade_da_parete],
    ["Namizne svetilke", "", "lampade-da-tavolo", lampade_da_tavolo],
    ["Talne svetilke", "", "lampade-da-terra", lampade_da_terra],
    ["Svetilke s priključkom", "", "lampade-plugin", lampade_plug_in],
    ["Zunanje svetilke", "", "lampade-outdoor", lampade_outdoor],
    ["Razdelilci in podaljški", "", "multiprese-e-prolunghe", multiprese_prolunghe],
    ["Ožičenje", "", "cablaggi", cablaggi],
    ["Rozete","","rosoni",rosoni],
];
